import React, { useState, useEffect, useContext } from "react";
import AddButton from "../../components/_default/AddButton";
import Icon from "../../components/_default/Icon";
import "./programs.scss";
import aurum from "../../assets/images/aurum.png";
import DropDown from "../../components/_default/DropDown";
import { getProgramsAurum, getProgramsCoach } from "../../services/firebase/firestore/getData";
import Spinner from "../../components/_default/Spinner";
import Popup from "../../components/_default/Popup";
import { deleteProgramAurum, deleteProgramCoach } from "../../services/firebase/firestore/deleteData";
import SearchPage from "../../components/_default/SearchPage";
import { deleteMediaArrayFromStorage } from "../../services/firebase/storage";
import UserContext from "../../services/context/userContext";
import sortAlphabetically from "../../services/defaultFunctions/sortAlphabetically";
import isIterable from "../../services/defaultFunctions/isIterable";
import { useCookies } from 'react-cookie';
import ProgramList from "../../components/_programs/ProgramList";
import logo from '../../assets/images/logo.svg';

function Programs(props) {
  const [cookies, setCookie] = useCookies(['from']);
  const _initial_categories = ["Upper", "Lower", "Mobility Drills", "Cardio", "Corrective Exercise Protocol"];
  const [checked, setChecked] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [programs, setPrograms] = useState({ aurum: false, coach: false });
  const [initialPrograms, setInitialPrograms] = useState({ aurum: false, coach: false });
  const [from, setFrom] = useState(cookies.from ? cookies.from : "aurum");
  const [categories, setCategories] = useState({ aurum: false, coach: false });
  let url = new URL(window.location.href);
  const [searchValue, setSearchValue] = useState('');

  const user = useContext(UserContext);

  const filters = ["Sort by name", "Sort by category"];
  const [filter, setFilter] = useState("Sort by name");
  const filterTypes = ["Ascending", "Descending"];
  const [filterType, setFilterType] = useState("Ascending");

  useEffect(() => {
    localStorage.removeItem("phasesArr")
    sorter({ ...programs });
  }, [filter, filterType])

  useEffect(() => {
    getPrograms();
  }, []);

  useEffect(() => {
    // set values from url params
    let search_params = url.searchParams;
    setSearchValue(search_params.get('search'));
    
    if(search_params.get('filter')) {
      setFilter(search_params.get('filter'))
    }
    if(search_params.get('filterType')) {
      setFilterType(search_params.get('filterType'));
    }
  }, []);

  useEffect(() => {
    handleCheck(false);
    setCookie('from', from, { path: '/' });
  }, [from]);

  function removeProgram(e) {
    let deleteUrlArray = [e.image, e.video_front, e.video_side];
    if (e.video_back) {
      deleteUrlArray.push(e.video_back);
    }
    // console.log(deleteUrlArray, e);
    deleteMediaArrayFromStorage(deleteUrlArray, () => {});
    if(e.from === "aurum"){
      // console.log(e.id);
      deleteProgramAurum(e.id, () => {
        getPrograms();
      });
    }else{
      deleteProgramCoach(user.id, e.id, () => {
        getPrograms();
      });
    }
  }

  function handleCheck(_category) {
    let _checked_categories = [...checked];

    if (_category) {
      if (_checked_categories.includes(_category)) {
        _checked_categories.splice(
          _checked_categories.findIndex((e) => e === _category),
          1
        );
      } else {
        _checked_categories.push(_category);
      }
      handleCategories(_checked_categories, initialPrograms, from);
    }    
  }

  function handleCategories(_checked_categories, initial, type) {
    if (isIterable(initial[type])) {
      let _checked_programs = [];
      if (_checked_categories.length > 0) {
        _checked_categories.map((item) => {
          _checked_programs = _checked_programs.concat(initial[type].filter((e) => e.category === item));
        });
      } else {
        _checked_programs = initial[type];
      }
      let _programs = { ...programs };
      
      _programs[type] = _checked_programs;
      setPrograms(_programs);
    }
    setChecked(_checked_categories);
  }

  function getPrograms() {
    getProgramsAurum((aurum_result) => {
      getProgramsCoach(user.id, (coach_result) => {
        handlePrograms({ aurum: { items: aurum_result, type: "aurum" }, coach: { items: coach_result, type: "coach" } });
      });
    });
  }

  function handlePrograms(result) {
    const _programs = { ...programs };
    _programs.aurum = result.aurum.items;
    _programs.coach = result.coach.items;
    // console.log("program debug",_programs)
    setInitialPrograms(_programs);
    setPrograms(_programs);
    Object.values(result).map((item) => {
      let filtered_by_category = [];
      item.items && item.items.map((item) => {
          let _index = filtered_by_category.findIndex((e) => e.category === item.category);
          if (_index !== -1) {
            filtered_by_category[_index].count += 1;
          } else {
            filtered_by_category.push({ category: item.category, count: 1 });
          }
          return filtered_by_category;
        });
      
        sorter(_programs);

      _initial_categories.map((item) => {
        let _index = filtered_by_category.findIndex((e) => e.category === item);
        if (_index === -1) {
          filtered_by_category.push({ category: item, count: 0 });
        }
      });

    });


    setShowPopup(false);
  }

  function sorter(programs) {
      if(programs.aurum) { 
        programs.aurum.sort((a,b) => {
          let firstCheck = filter === "Sort by category"? a.category : a.name;
          let secondCheck = filter === "Sort by category"? b.category : b.name;
          if (firstCheck > secondCheck) {
            return filterType == "Ascending"? 1 : -1;
          }
          if (secondCheck > firstCheck) {
            return filterType == "Ascending"? -1 : 1;
          }
            return 0;
          });
      }
      if(programs.coach) {
        programs.coach.sort((a,b) => {
          let firstCheck = filter === "Sort by category"? a.category : a.name;
          let secondCheck = filter === "Sort by category"? b.category : b.name;
          if (firstCheck > secondCheck) {
            return filterType == "Ascending"? 1 : -1;
          }
          if (secondCheck > firstCheck) {
            return filterType == "Ascending"? -1 : 1;
          }
          return 0;
        });
      }
   
      setPrograms(programs);
  }

  function searchExerciseList(e) {
    setSearchValue(e);
    let search_params = url.searchParams;
    search_params.set('search', e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);

    getProgramsAurum((aurum_result) => {
      getProgramsCoach(user.id, (coach_result) => {
        handlePrograms({ aurum: { items: aurum_result, type: "aurum" }, coach: { items: coach_result, type: "coach" } });
        let finalResult = { aurum: { items: [], type: "aurum" }, coach: { items: [], type: "coach" } }

        if(programs.aurum) {
          programs.aurum.map((item) => {
            if(item.name.toLowerCase().includes(e.toLowerCase())) {
              finalResult.aurum.items.push(item);
            }
          })
        }
        if(programs.coach) {
          programs.coach.map((item) => {
            if(item.name.toLowerCase().includes(e.toLowerCase())) {
              finalResult.coach.items.push(item);
            }
          })
        }

        if(e === "") {
          handlePrograms({ aurum: { items: aurum_result, type: "aurum" }, coach: { items: coach_result, type: "coach" } });
        }else {
          handlePrograms(finalResult);
        }  
      });
    });
  }

  function setFilterParam(e) {
    let search_params = url.searchParams;
    search_params.set('filter', e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  function setFilterTypeParam(e) {
    let search_params = url.searchParams;
    search_params.set('filterType', e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  function setParamsCategories(cat) {
    let _checked_categories = [...checked];

    if (_checked_categories.includes(cat)) {
      _checked_categories.splice(
        _checked_categories.findIndex((e) => e === cat),
        1
      );
    } else {
      _checked_categories.push(cat);
    }

    let checkedCats = "";
    _checked_categories.forEach(element => {
      if(checkedCats !== "") {
        checkedCats += ";";
      }
      checkedCats += element;
    })

    let search_params = url.searchParams;
    search_params.set('categories', checkedCats);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  return (
    <div className="c-page-wrapper c-page-dashboard c-page-exercises">
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav">
            <h1 className="c-header-title">Programs</h1>
            <ul className="c-header-nav-wrapper">
              <li className={from === "aurum" ? "--active" : ""} onClick={() => setFrom("aurum")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
                <p>Aurum <span>({initialPrograms.aurum.length})</span></p>
              </li>
              <li className={from === "coach" ? "--active" : ""} onClick={() => setFrom("coach")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
                  <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>
                </div>
                <p>{user.first_name} <span>({initialPrograms.coach ? initialPrograms.coach.length : 0})</span> </p>
              </li>
            </ul>
          </div>
          <div className="c-header-add">
            <AddButton text="Add Program" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/program", { update: false, from: from })} />
          </div>
          <div className="c-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      <div className="c-page-wrapper--exercises">
        <div className="c-page-main--exercises">
          <div className="c-exercise-finder">
            <SearchPage placeholder="Search program" value={searchValue} onChange={(e) => {searchExerciseList(e.target.value)}} />
            <div className="c-dropdown-holder">
              <DropDown options={filters} value={filter} onChange={(e) => {setFilter(e); setFilterParam(e)}} />
              <DropDown options={filterTypes} value={filterType} onChange={(e) => {setFilterType(e); setFilterTypeParam(e)}} />
            </div>
          </div>

          {!programs ? (
              <div className="c-list-loader">
                <Spinner />
                </div>
            ):
            <ProgramList programs={programs[from]} from={from} history={props.history} removeProgram={(e) => setShowPopup({ from: from, type: "program", ...e })}/>
          }
        </div>
      </div>
      {showPopup && (
        <Popup
          title={"Delete program"}
          button="Delete"
          deletePopup={true}
          description={"Are you sure you want to delete this program? This can not be undone."}
          onAction={() => removeProgram(showPopup)}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
}

export default Programs;
